module.exports = __webpack_public_path__ + "img/symbol_2.ec6945dc.png";